import { FilterOption, TickIcon, XCloseIcon } from "assests";
import { Button } from "components/UI/Button";
import CustomDropdownCard from "components/UI/CustomDropdownCard";
import TransparencySlider from "components/UI/TransparencySlider";
import { useEffect, useRef, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { useSelector } from "react-redux";
import { filterNonEmptyKeys } from "utils/helper";
const SubSupplierFilter = ({
  activeFilters,
  setActiveFilters,
  setFilteredData,
  subSupplierOptions,
  setPage,
}) => {
  const [isHovered, setIshovered] = useState(false);
  const { user, currentWorkspace } = useSelector((state) => state.authenticationSlice);
  const filterOptions = [
    "partner_name",
    "type",

    "active_orders",

    "verification",
    "street",
    "city",
    "country",
    "tier",
  ];

  const typeOptions = [
    {
      label: "Retailer",
      value: "retailer",
    },
    {
      label: "Importer",
      value: "importer",
    },
    {
      label: "Brand",
      value: "brand",
    },
  ];
  const filterRef = useRef(null);
  const childfilterRef = useRef(null);
  const [transparencyRange, setTransparencyRange] = useState([0, 100]);
  const [transparencyScoreRange, setTransparencyScoreRange] = useState([0, 100]);
  const [varificationRange, setVarificationRange] = useState([0, 100]);
  const [hoveredId, setHoveredId] = useState({});
  const [mainDropdownVisible, setMainDropdownVisible] = useState(false);
  const [currentFilterDropdown, setCurrentFilterDropdown] = useState(null);
  const [uniqueCountries, setUniqueCountries] = useState([]);
  const [uniqueCities, setUniqueCities] = useState([]);
  const [uniqueStreets, setUniqueStreets] = useState([]);
  // Toggle Main Dropdown
  const toggleMainDropdown = () => {
    setMainDropdownVisible(!mainDropdownVisible);
    setCurrentFilterDropdown(null);
  };

  // Add Filter
  const addFilter = (filterName) => {
    if (!activeFilters[filterName]) {
      setActiveFilters((prev) => ({
        ...prev,
        [filterName]: filterName === "Active Orders" ? transparencyRange : [],
      }));
    }
  };

  // Remove Filter
  const removeFilter = (filterName) => {
    setActiveFilters((prev) => {
      const updatedFilters = { ...prev };
      delete updatedFilters[filterName];
      return updatedFilters;
    });
    setCurrentFilterDropdown(null);
    if (filterName === "active_orders") {
      setTransparencyRange([0, 100]);
    }
    // if (filterName === "transparency") {
    //   setTransparencyScoreRange([0, 100]);
    // }
    if (filterName === "verification") {
      setVarificationRange([0, 100]);
    }
  };

  const addFilterValue = (filterName, value, label) => {
    setActiveFilters((prev) => {
      const updatedValues = prev[filterName] || [];
      if (!updatedValues.some((item) => item.value === value)) {
        updatedValues.push({ value, label });
      }
      // Return the updated filters
      return { ...prev, [filterName]: updatedValues };
    });
  };

  const removeFilterValue = (filterName, value) => {
    setActiveFilters((prev) => {
      const updatedValues = prev[filterName]?.filter((item) => item.value !== value);
      if (!updatedValues || updatedValues.length === 0) {
        const { [filterName]: _, ...rest } = prev; // Destructure to exclude the filterName
        return rest;
      }
      return { ...prev, [filterName]: updatedValues };
    });
  };

  // Handle Transparency Slider Change
  const handleSliderChange = (range) => {
    setTransparencyRange(range);
    setActiveFilters((prev) => ({
      ...prev,
      active_orders: range,
    }));
  };

  const handleVarificationScoreSliderChange = (range) => {
    setVarificationRange(range);
    setActiveFilters((prev) => ({
      ...prev,
      verification: range,
    }));
  };

  useEffect(() => {
    if (activeFilters) {
      const transformedData = {
        filter_by_active_orders: activeFilters.active_orders,

        verification_score: activeFilters.verification,
        // filter_by_status: activeFilters.status,
        sub_tier: activeFilters.type,
        name: activeFilters.partner_name,
        filter_by_street: activeFilters.street,
        filter_by_city: activeFilters.city,
        filter_by_country: activeFilters.country,
        tier: activeFilters.tier,
      };
      const updatedFilteredData = filterNonEmptyKeys(transformedData);
      setFilteredData(updatedFilteredData);
      if (Object.keys(updatedFilteredData).length !== 0) {
        setPage(1);
      }
    }
  }, [activeFilters]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setMainDropdownVisible(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (childfilterRef.current && !childfilterRef.current.contains(event.target)) {
        setCurrentFilterDropdown(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [currentFilterDropdown]);

  const processUniqueData = () => {
    // Extract unique countries
    const countries = [
      ...new Set(
        subSupplierOptions
          .map((item) => item.country)
          .filter((country) => country && country.trim() !== ""),
      ),
    ];
    setUniqueCountries(countries);
    // Extract unique cities
    const cities = [
      ...new Set(
        subSupplierOptions
          .map((item) => item.region)
          .filter((region) => region && region.trim() !== ""),
      ),
    ];
    setUniqueCities(cities);
    // Extract unique streets
    const streets = [
      ...new Set(
        subSupplierOptions
          .map((item) => item.street)
          .filter((street) => street && street.trim() !== ""),
      ),
    ];
    setUniqueStreets(streets);
  };

  useEffect(() => {
    if (subSupplierOptions && subSupplierOptions.length > 0) {
      processUniqueData();
    }
  }, [subSupplierOptions]);

  useEffect(() => {
    if (user && currentWorkspace) {
      const handleKeyDown = (event) => {
        // Check if 'Ctrl + R' is pressed

        if (
          (event.ctrlKey || event.metaKey) &&
          event.shiftKey &&
          (event.key === "Y" || event.key === "y")
        ) {
          event.preventDefault();
          setMainDropdownVisible(true);
        }
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [user, currentWorkspace]);

  return (
    <div
      className={`flex flex-col md:flex-row md:flex-wrap  w-full ${activeFilters && Object.keys(activeFilters).length > 0 && "gap-2"}`}
    >
      <div
        ref={childfilterRef}
        className="flex flex-col md:flex-row md:flex-wrap gap-2 order-2 md:order-1"
      >
        {activeFilters &&
          Object.keys(activeFilters).map((filter) => (
            <div key={filter} className="relative">
              <Button
                variant="secondary"
                className="text-txt-secondary px-3.5 py-2.5 justify-between h-10 lg:h-auto  gap-1 truncate w-full md:w-auto text-sm tracking-wide font-normal  flex"
                onClick={() => {
                  setCurrentFilterDropdown(currentFilterDropdown === filter ? null : filter);
                  setMainDropdownVisible(false);
                }}
              >
                <div>
                  <span className="capitalize">
                    {filter && filter === "verification"
                      ? `${filter} %`
                      : filter?.replace(/_/g, " ")}
                  </span>
                  :
                  {(filter === "date_added" || filter === "last_updated") &&
                  activeFilters[filter] ? (
                    <span className="font-semibold">
                      {" "}
                      {activeFilters[filter]?.startDate && activeFilters[filter]?.endDate
                        ? `${activeFilters[filter].startDate} ~ ${activeFilters[filter].endDate}`
                        : null}
                    </span>
                  ) : activeFilters[filter]?.length > 0 ? (
                    <span className="font-semibold">
                      {" "}
                      {activeFilters[filter].length > 2
                        ? "Multiple"
                        : activeFilters[filter]
                            .map((status) =>
                              typeof status === "object" && status.label ? status.label : status,
                            )
                            .join(", ")}
                    </span>
                  ) : null}
                </div>
                <div>
                  <RxCross2
                    size={20}
                    onClick={(e) => {
                      e.stopPropagation();
                      removeFilter(filter);
                    }}
                    className="cursor-pointer"
                  />
                </div>
              </Button>

              {/* Sub-dropdown for Status and partner_name*/}
              {currentFilterDropdown === filter && filter === "partner_name" && (
                <CustomDropdownCard>
                  {subSupplierOptions && subSupplierOptions.length > 0 ? (
                    subSupplierOptions.map((article, index) => {
                      const isSelected = activeFilters[filter]?.some(
                        (item) => item.value === article.name,
                      );
                      return (
                        <div
                          key={index}
                          onClick={(e) => {
                            e.stopPropagation();
                            addFilterValue(filter, article.name, article.name);
                          }}
                          onMouseEnter={() => setHoveredId(article.name)}
                          onMouseLeave={() => setHoveredId(null)}
                          className={`cursor-pointer flex items-center justify-start w-full pl-2 pr-2.5 py-2.5 rounded-md hover:bg-global-white ${
                            isSelected ? "bg-global-white" : ""
                          }`}
                        >
                          <span className="text-base font-medium text-global-title truncate">
                            {article.name}
                          </span>
                          {isSelected && (
                            <span className="ml-auto">
                              {hoveredId === article.name ? (
                                <XCloseIcon
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removeFilterValue(filter, article.name);
                                  }}
                                  strokeColor={"var(--color-login-text-title)"}
                                  width={20}
                                  height={20}
                                />
                              ) : (
                                <TickIcon width={20} height={20} />
                              )}
                            </span>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <p className="text-base px-6 py-5 font-normal text-center text-global-gray-brand">
                      No data found
                    </p>
                  )}
                </CustomDropdownCard>
              )}

              {currentFilterDropdown === filter && filter === "tier" && (
                <CustomDropdownCard>
                  {subSupplierOptions && subSupplierOptions.length > 0 ? (
                    Array.from(
                      new Set(
                        subSupplierOptions.flatMap((supplier) =>
                          supplier.sub_tiers.map((sub) => sub.tier_id),
                        ),
                      ),
                    )
                      .sort((a, b) => a - b)
                      .map((tierId, index) => {
                        const displayTierId = tierId - 1; // Shifted label
                        const isSelected = activeFilters[filter]?.some(
                          (item) => item.value === tierId,
                        );
                        return (
                          <div
                            key={index}
                            onClick={(e) => {
                              e.stopPropagation();
                              addFilterValue(filter, tierId, `${displayTierId}`);
                            }}
                            onMouseEnter={() => setHoveredId(tierId)}
                            onMouseLeave={() => setHoveredId(null)}
                            className={`cursor-pointer flex items-center justify-start w-full pl-2 pr-2.5 py-2.5 rounded-md hover:bg-global-white ${
                              isSelected ? "bg-global-white" : ""
                            }`}
                          >
                            <span className="text-base font-medium text-global-title truncate">
                              {`Tier ${displayTierId}`}
                            </span>
                            {isSelected && (
                              <span className="ml-auto">
                                {hoveredId === tierId ? (
                                  <XCloseIcon
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removeFilterValue(filter, tierId);
                                    }}
                                    strokeColor={"var(--color-login-text-title)"}
                                    width={20}
                                    height={20}
                                  />
                                ) : (
                                  <TickIcon width={20} height={20} />
                                )}
                              </span>
                            )}
                          </div>
                        );
                      })
                  ) : (
                    <p className="text-base px-6 py-5 font-normal text-center text-global-gray-brand">
                      No data found
                    </p>
                  )}
                </CustomDropdownCard>
              )}

              {currentFilterDropdown === filter && filter === "certificates" && (
                <CustomDropdownCard>
                  {subSupplierOptions && subSupplierOptions.length > 0 ? (
                    subSupplierOptions.flatMap((supplier) =>
                      supplier.certificates.map((article) => {
                        const isSelected = activeFilters[filter]?.some(
                          (item) => item.value === article.certificate_type_id,
                        );
                        return (
                          <div
                            key={article.certificate_type_id} // Use a unique identifier
                            onClick={(e) => {
                              e.stopPropagation();
                              addFilterValue(
                                filter,
                                article.certificate_type_id,
                                article.certified_by.name,
                              );
                            }}
                            onMouseEnter={() => setHoveredId(article.certificate_type_id)}
                            onMouseLeave={() => setHoveredId(null)}
                            className={`cursor-pointer flex items-center justify-start w-full pl-2 pr-2.5 py-2.5 rounded-md hover:bg-global-white ${
                              isSelected ? "bg-global-white" : ""
                            }`}
                          >
                            <span className="text-base font-medium text-global-title truncate">
                              {article.certified_by.name}
                            </span>
                            {isSelected && (
                              <span className="ml-auto">
                                {hoveredId === article.certificate_type_id ? (
                                  <XCloseIcon
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removeFilterValue(filter, article.certificate_type_id);
                                    }}
                                    strokeColor={"var(--color-login-text-title)"}
                                    width={20}
                                    height={20}
                                  />
                                ) : (
                                  <TickIcon width={20} height={20} />
                                )}
                              </span>
                            )}
                          </div>
                        );
                      }),
                    )
                  ) : (
                    <p className="text-base px-6 py-5 font-normal text-center text-global-gray-brand">
                      No data found
                    </p>
                  )}
                </CustomDropdownCard>
              )}

              {/* Sub-dropdown for Transparency Score */}
              {currentFilterDropdown === filter && filter === "active_orders" && (
                <CustomDropdownCard className="w-[292px] md:w-[320px]">
                  <TransparencySlider
                    setTransparencyRange={setTransparencyRange}
                    transparencyRange={transparencyRange}
                    onChange={handleSliderChange}
                    maxValue={100}
                    minValue={0}
                  />
                </CustomDropdownCard>
              )}

              {currentFilterDropdown === filter && filter === "verification" && (
                <CustomDropdownCard className="w-[292px] md:w-[320px]">
                  <TransparencySlider
                    setTransparencyRange={setVarificationRange}
                    transparencyRange={varificationRange}
                    onChange={handleVarificationScoreSliderChange}
                    maxValue={100}
                    minValue={0}
                  />
                </CustomDropdownCard>
              )}
              {/* {currentFilterDropdown === filter && filter === "type" && (
                <CustomDropdownCard>
                  {subSupplierOptions && subSupplierOptions.length > 0 ? (
                    subSupplierOptions
                      .filter(
                        (value, index, self) =>
                          index === self.findIndex((t) => t.type === value.type),
                      ) // Filter duplicates based on type
                      .map((status, index) => {
                        const isSelected = activeFilters[filter]?.some(
                          (item) => item.value === status.type,
                        );
                        return (
                          <div
                            key={index}
                            onClick={(e) => {
                              e.stopPropagation();
                              addFilterValue(filter, status.type, status.type);
                            }}
                            onMouseEnter={() => setHoveredId(status.type)}
                            onMouseLeave={() => setHoveredId(null)}
                            className={`cursor-pointer flex items-center justify-start w-full pl-2 pr-2.5 py-2.5 rounded-md hover:bg-global-white ${
                              isSelected ? "bg-global-white" : ""
                            }`}
                          >
                            <span className="text-base font-medium text-global-title truncate">
                              {status.type}
                            </span>
                            {isSelected && (
                              <span className="ml-auto">
                                {hoveredId === status.type ? (
                                  <XCloseIcon
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removeFilterValue(filter, status.type);
                                    }}
                                    strokeColor={"var(--color-login-text-title)"}
                                    width={20}
                                    height={20}
                                  />
                                ) : (
                                  <TickIcon width={20} height={20} />
                                )}
                              </span>
                            )}
                          </div>
                        );
                      })
                  ) : (
                    <p className="text-base px-6 py-5 font-normal text-center text-global-gray-brand">
                      No data found
                    </p>
                  )}
                </CustomDropdownCard>
              )} */}

              {currentFilterDropdown === filter && filter === "type" && (
                <CustomDropdownCard>
                  {subSupplierOptions && subSupplierOptions.length > 0 ? (
                    // Step 1: Flatten all types from all sub_tiers
                    Array.from(
                      new Set(
                        subSupplierOptions.flatMap((supplier) =>
                          supplier.sub_tiers.map((sub) => sub.type),
                        ),
                      ),
                    )
                      .sort() // Optional: sort alphabetically
                      .map((type, index) => {
                        const isSelected = activeFilters[filter]?.some(
                          (item) => item.value === type,
                        );

                        return (
                          <div
                            key={index}
                            onClick={(e) => {
                              e.stopPropagation();
                              addFilterValue(filter, type, type); // ✅ type is both value and label
                            }}
                            onMouseEnter={() => setHoveredId(type)}
                            onMouseLeave={() => setHoveredId(null)}
                            className={`cursor-pointer flex items-center justify-start w-full pl-2 pr-2.5 py-2.5 rounded-md hover:bg-global-white ${
                              isSelected ? "bg-global-white" : ""
                            }`}
                          >
                            <span className="text-base font-medium text-global-title truncate">
                              {type}
                            </span>
                            {isSelected && (
                              <span className="ml-auto">
                                {hoveredId === type ? (
                                  <XCloseIcon
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removeFilterValue(filter, type);
                                    }}
                                    strokeColor={"var(--color-login-text-title)"}
                                    width={20}
                                    height={20}
                                  />
                                ) : (
                                  <TickIcon width={20} height={20} />
                                )}
                              </span>
                            )}
                          </div>
                        );
                      })
                  ) : (
                    <p className="text-base px-6 py-5 font-normal text-center text-global-gray-brand">
                      No data found
                    </p>
                  )}
                </CustomDropdownCard>
              )}

              {currentFilterDropdown === filter && filter === "street" && (
                <CustomDropdownCard>
                  {uniqueStreets && uniqueStreets.length > 0 ? (
                    uniqueStreets.map((article, index) => {
                      const isSelected = activeFilters[filter]?.some(
                        (item) => item.value === article,
                      );
                      return (
                        <div
                          key={index}
                          onClick={(e) => {
                            e.stopPropagation();
                            addFilterValue(filter, article, article);
                          }}
                          onMouseEnter={() => setHoveredId(article)}
                          onMouseLeave={() => setHoveredId(null)}
                          className={`cursor-pointer flex items-center justify-start w-full pl-2 pr-2.5 py-2.5 rounded-md hover:bg-global-white ${
                            isSelected ? "bg-global-white" : ""
                          }`}
                        >
                          <span className="text-base font-medium text-global-title truncate">
                            {article}
                          </span>
                          {isSelected && (
                            <span className="ml-auto">
                              {hoveredId === article ? (
                                <XCloseIcon
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removeFilterValue(filter, article);
                                  }}
                                  strokeColor={"var(--color-login-text-title)"}
                                  width={20}
                                  height={20}
                                />
                              ) : (
                                <TickIcon width={20} height={20} />
                              )}
                            </span>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <p className="text-base px-6 py-5 font-normal text-center text-global-gray-brand">
                      No data found
                    </p>
                  )}
                </CustomDropdownCard>
              )}
              {currentFilterDropdown === filter && filter === "city" && (
                <CustomDropdownCard>
                  {uniqueCities && uniqueCities.length > 0 ? (
                    uniqueCities.map((article, index) => {
                      const isSelected = activeFilters[filter]?.some(
                        (item) => item.value === article,
                      );
                      return (
                        <div
                          key={index}
                          onClick={(e) => {
                            e.stopPropagation();
                            addFilterValue(filter, article, article);
                          }}
                          onMouseEnter={() => setHoveredId(article)}
                          onMouseLeave={() => setHoveredId(null)}
                          className={`cursor-pointer flex items-center justify-start w-full pl-2 pr-2.5 py-2.5 rounded-md hover:bg-global-white ${
                            isSelected ? "bg-global-white" : ""
                          }`}
                        >
                          <span className="text-base font-medium text-global-title truncate">
                            {article}
                          </span>
                          {isSelected && (
                            <span className="ml-auto">
                              {hoveredId === article ? (
                                <XCloseIcon
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removeFilterValue(filter, article);
                                  }}
                                  strokeColor={"var(--color-login-text-title)"}
                                  width={20}
                                  height={20}
                                />
                              ) : (
                                <TickIcon width={20} height={20} />
                              )}
                            </span>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <p className="text-base px-6 py-5 font-normal text-center text-global-gray-brand">
                      No data found
                    </p>
                  )}
                </CustomDropdownCard>
              )}
              {currentFilterDropdown === filter && filter === "country" && (
                <CustomDropdownCard>
                  {uniqueCountries && uniqueCountries.length > 0 ? (
                    uniqueCountries.map((article, index) => {
                      const isSelected = activeFilters[filter]?.some(
                        (item) => item.value === article,
                      );
                      return (
                        <div
                          key={index}
                          onClick={(e) => {
                            e.stopPropagation();
                            addFilterValue(filter, article, article);
                          }}
                          onMouseEnter={() => setHoveredId(article)}
                          onMouseLeave={() => setHoveredId(null)}
                          className={`cursor-pointer flex items-center justify-start w-full pl-2 pr-2.5 py-2.5 rounded-md hover:bg-global-white ${
                            isSelected ? "bg-global-white" : ""
                          }`}
                        >
                          <span className="text-base font-medium text-global-title truncate">
                            {article}
                          </span>
                          {isSelected && (
                            <span className="ml-auto">
                              {hoveredId === article ? (
                                <XCloseIcon
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removeFilterValue(filter, article);
                                  }}
                                  strokeColor={"var(--color-login-text-title)"}
                                  width={20}
                                  height={20}
                                />
                              ) : (
                                <TickIcon width={20} height={20} />
                              )}
                            </span>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <p className="text-base px-6 py-5 font-normal text-center text-global-gray-brand">
                      No data found
                    </p>
                  )}
                </CustomDropdownCard>
              )}
            </div>
          ))}
      </div>
      <div className="order-1 md:order-2">
        <div ref={filterRef} className="w-full md:w-auto">
          <Button
            variant="secondary"
            className="text-txt-secondary px-[15.08px] py-2.5 w-full md:w-auto gap-1.5 text-sm  tracking-normal font-semibold flex h-10 lg:h-auto"
            onMouseEnter={() => setIshovered(true)}
            onMouseLeave={() => setIshovered(false)}
            onClick={toggleMainDropdown}
          >
            <FilterOption
              width={20}
              height={20}
              strokeColor={
                isHovered ? "var(--color-icon-fill-secondary-button)" : "var(--color-txt-secondary)"
              }
            />
            {Object.keys(activeFilters).length > 0 ? (
              "More filters"
            ) : (
              <span className="tracking-[0.01em]">Filters</span>
            )}
          </Button>

          {mainDropdownVisible && (
            <CustomDropdownCard>
              {filterOptions.map((filter, index) => {
                const isSelected = activeFilters[filter];
                return (
                  <div
                    key={index}
                    onClick={() => addFilter(filter)}
                    onMouseEnter={() => setHoveredId(filter)}
                    onMouseLeave={() => setHoveredId(null)}
                    className={`cursor-pointer flex gap-2 flex-wrap items-center justify-start w-full pl-2 pr-2.5 py-2.5 rounded-md hover:bg-global-white ${
                      isSelected ? "bg-global-white" : ""
                    }`}
                  >
                    <span className="text-base font-medium text-global-title truncate capitalize">
                      <span className="capitalize">
                        {filter && filter === "verification"
                          ? `${filter} %`
                          : filter?.replace(/_/g, " ")}
                      </span>
                    </span>
                    {isSelected && (
                      <span className="ml-auto">
                        {hoveredId === filter ? (
                          <XCloseIcon
                            onClick={(e) => {
                              e.stopPropagation();
                              removeFilter(filter);
                            }}
                            strokeColor={"var(--color-login-text-title)"}
                            width={20}
                            height={20}
                          />
                        ) : (
                          <TickIcon width={20} height={20} />
                        )}
                      </span>
                    )}
                  </div>
                );
              })}
            </CustomDropdownCard>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubSupplierFilter;
